<div class="info-container" *ngIf="type">
    <div class="info-message" [ngClass]="getInfoMessageClass()">
        <mat-icon class="pme-info-message-icon" [ngClass]="getInfoMessageIconClass()">{{getIconContent()}}</mat-icon>

        <div class="info-message-text">
            <p class="info-msg-title" [ngClass]="getMessageTitleClass()" [innerHTML]="title" *ngIf="title"></p>
            <ng-content class="content"></ng-content>
        </div>
    </div>
</div>